import { environment } from '@environments/environment';
import { AuthGuard } from '@infodocs/shared/guards/auth.guard';
import { SubscriptionPortfolioGuard } from '@infodocs/shared/guards/subscription-portfolio.guard';


export const portfolioRoutes = [
	{
		path: '',
		canActivate: [AuthGuard],
		children: [
			{
				path: '',
				pathMatch: 'full',
				loadComponent: () => import('./portfolio-experience-redirect.component').then(m => m.PortfolioExperienceRedirectComponent),
			},
			{
				path: 'company',
				loadComponent: () => import('./pages/company-portfolio/company-portfolio.component').then(m => m.CompanyPortfolioComponent),
			},
			{
				path: 'companies',
				canActivate: [SubscriptionPortfolioGuard],
				loadComponent: () => import('./pages/company-portfolio-v2/company-portfolio-v2.component').then(m => m.CompanyPortfolioV2Component),
			},
			...(environment.trustsEnabled ? [{
				path: 'trust',
				loadComponent: () => import('./pages/trust-portfolio/trust-portfolio.component').then(m => m.TrustPortfolioComponent)
			}] : []),
			{
				path: 'individuals',
				loadComponent: () => import('./pages/individual-portfolio/individual-portfolio.component').then(m => m.IndividualPortfolioComponent),
			},
		],
	},

	// fallback route
	{
		path: '**',
		loadComponent: () => import('../public/pages/error-page/error-page.component').then(m => m.ErrorPageComponent), // ErrorPageComponent,
	},
] satisfies import('@angular/router').Routes;
